import React from 'react';
type TextFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  name: string;
  error?: string;
  hint?: string;
};
export const fieldClass = 'mt-2 w-full border border-ink-line bg-ink-surface px-4 py-3 text-white placeholder:text-ink-faint transition-colors duration-150 ease-out focus:border-white focus:outline-none';
export function TextField({
  label,
  name,
  error,
  hint,
  required,
  className = '',
  ...rest
}: TextFieldProps) {
  const id = `field-${name}`;
  return <div className={className} data-id="element-73" data-mp="34hy1s33j09r2">
      <label htmlFor={id} className="font-slab text-xs font-bold uppercase tracking-[0.2em]" data-id="element-74" data-mp="34j921sxrizdf">
        {label}
        {required && <span className="text-ink-muted" data-id="element-75" data-mp="39fziwihe5yzw"> *</span>}
      </label>
      <input id={id} name={name} required={required} aria-invalid={!!error} aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined} className={`${fieldClass} ${error ? 'border-red-400' : ''}`} {...rest} data-id="element-76" data-mp="3e9asgrdl8tvi" />
      {hint && !error && <p id={`${id}-hint`} className="mt-1.5 text-xs text-ink-faint" data-id="element-77" data-mp="1hhwq28mv6u7w">
          {hint}
        </p>}
      {error && <p id={`${id}-error`} className="mt-1.5 text-xs text-red-300" data-id="element-78" data-mp="18qebu39haohg">
          {error}
        </p>}
    </div>;
}